import { StandardLink } from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';
import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface PeopleTaggingProps {
  defaultEnabled: boolean | null;
}

const description = (
  <>
    <Trans>Allow photos of people to be automatically tagged after a person has been identified and tagged by an Admin or Contributor.</Trans>
    {'  '}
    <StandardLink className="terms-link" href="https://www.smartsheet.com/legal/user-agreement" target="_blank">
      <Trans>Terms apply</Trans>
    </StandardLink>
  </>
);

const PeopleTagging: FunctionComponent<PeopleTaggingProps> = ({ defaultEnabled }) => {
  const handleUpdate = (enabled: boolean): void => {
    if (BFG.brandfolderSettings) {
      BFG.brandfolderSettings.people_tagging = enabled;
    }
  };

  return (
    <I18nProviderWrapper>
      <SettingsEnableDisable
        defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
        description={description}
        errorTitle={t`Error updating AI People Tagging setting. Please contact support.`}
        id="people-tagging-setting"
        isNew={true}
        onUpdate={handleUpdate}
        showDisableInfoModal={true}
        successTitle={t`AI People Tagging is <status>. We’re processing your assets now. People tags will appear once processing is complete.`}
        successTitleDisabled={t`People Tagging is now disabled.`}
        title={t`AI People Tagging`}
        updateResourceKey="peopleTagging"
      />
    </I18nProviderWrapper>
  );
};

export default PeopleTagging;
